/**
 * @generated SignedSource<<27fe870abb475c98a700099a2b46a4e9>>
 * @relayHash 82e86ab31dcc8998c08c9dff04b79539
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bea779f02554ae113cdbc2c84495adba726eb9872087aa90313a541f7931b6a7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevAiFlowSessionsStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PAUSED" | "PENDING" | "%future added value";
export type sessionsListQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  creator: string;
  first?: number | null | undefined;
  statusFilter?: DevAiFlowSessionsStatus | null | undefined;
};
export type sessionsListQuery$data = {
  readonly devai_flowSessionsConnectionByCreatorAndCloudId: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly additionalInfoJSON: string | null | undefined;
        readonly id: string;
        readonly sessionARI: string;
        readonly status: DevAiFlowSessionsStatus | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type sessionsListQuery = {
  response: sessionsListQuery$data;
  variables: sessionsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statusFilter"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "creator",
        "variableName": "creator"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "statusFilter",
        "variableName": "statusFilter"
      }
    ],
    "concreteType": "DevAiFlowSessionConnection",
    "kind": "LinkedField",
    "name": "devai_flowSessionsConnectionByCreatorAndCloudId",
    "plural": false,
    "selections": [
      {
        "concreteType": "DevAiFlowSessionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "DevAiFlowSession",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "sessionARI"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "kind": "ScalarField",
                "name": "additionalInfoJSON"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "sessionsListQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "sessionsListQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "bea779f02554ae113cdbc2c84495adba726eb9872087aa90313a541f7931b6a7",
    "metadata": {},
    "name": "sessionsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fe3c81b5a3babda7210e1f014322d7e0";

export default node;
